import api from 'common/api';

export const getFilterBLInformationAPI = (params: any) => api.get('/bl-information/search', params);

export const getDetailCargoInfoAPI = (params: any) => api.get('/cargo-information/detail', params);

export const updateCargoInfoAPI = (params: any) => api.put('/cargo-information', params);

export const deleteCargoInfoAPI = (params: any) => api.put('/cargo-information/delete-bl', params);

export const addCargoInfoAPI = (params: any) => api.post('/cargo-information', params);
